module.exports = __webpack_public_path__ + "static/media/sub-cool-temp.eb63f5f6.svg";